// components/industry-templates/BusinessEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Briefcase, Users, TrendingUp, Award } from 'lucide-react';

export const BusinessEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Panel Discussions */}
      {industryData?.panel_discussions && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Users className="w-6 h-6" style={{ color: theme.primary }} />
              Panel Discussions & Keynotes
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {industryData.panel_discussions.map((panel: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg border border-white/10">
                  <h4 className="font-bold text-white mb-2">{panel.topic}</h4>
                  <div className="flex flex-wrap gap-2 mb-2">
                    {panel.panelists?.map((panelist: string, i: number) => (
                      <Badge key={i} style={{ backgroundColor: theme.primary }}>{panelist}</Badge>
                    ))}
                  </div>
                  <p className="text-sm text-slate-400">{panel.time}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Networking Sessions */}
      {industryData?.networking_sessions && (
        <Card className="border-0 bg-gradient-to-br from-slate-700/20 to-gray-700/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Briefcase className="w-6 h-6" style={{ color: theme.primary }} />
              Networking Opportunities
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4">
              {industryData.networking_sessions.map((session: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg text-center">
                  <h4 className="font-bold text-white mb-1">{session.type}</h4>
                  <p className="text-sm text-slate-400">{session.time}</p>
                  {session.capacity && (
                    <Badge variant="outline" className="mt-2 border-white/20 text-white">
                      Capacity: {session.capacity}
                    </Badge>
                  )}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Pitch Competition */}
      {industryData?.pitch_competition && (
        <Card className="border-2" style={{ borderColor: theme.primary, backgroundColor: 'rgba(71, 85, 105, 0.1)' }}>
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <TrendingUp className="w-6 h-6" style={{ color: theme.primary }} />
              Startup Pitch Competition
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <div className="bg-white/5 rounded-lg p-4">
                <p className="text-2xl font-bold" style={{ color: theme.primary }}>
                  Prize Pool: {industryData.pitch_competition.prize_pool}
                </p>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="p-3 bg-white/5 rounded-lg text-center">
                  <p className="text-xl font-bold text-white">{industryData.pitch_competition.slots}</p>
                  <p className="text-xs text-slate-400">Presentation Slots</p>
                </div>
                <div className="p-3 bg-white/5 rounded-lg text-center">
                  <p className="text-xl font-bold text-white">{industryData.pitch_competition.judges}</p>
                  <p className="text-xs text-slate-400">Expert Judges</p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
